module.exports = __webpack_public_path__ + "static/media/guanli4.0ac868bd.png";